import React, { useEffect, useState } from "react";

// スタイルインポート
import "../../pages/css/works.scss";
import "../../responsive/WorksResponsive.scss";
import "../../common.scss";

// 縦線
import line from "../../img/services/Rectangle.svg";

// 制作事例01
import work01 from "../../img/works/work01.png";
import work02 from "../../img/works/billier.PNG";
import work03 from "../../img/works/daymy.PNG";
import work04 from "../../img/works/finance.PNG";
import work05 from "../../img/works/neru.PNG";
import work06 from "../../img/works/nix.PNG";

function HomePage() {
    const webList = [
        {
            name: "foods kurata",
            img: "/static/media/work01.c0736d73b992e46e2dad.png",
            siteName: "らぅめんの善栄",
            release: "2022/07/19",
            webType: "コーポレートサイト",
            url: "https://raumennoyoshiei.com/",
            positionTop: "SmartGenz",
            positionDesign: "SmartGenz",
            positionCoding: "SMartGenz",
            positionServer: "SMartGenz",
        },
        {
            name: "portSite kurata",
            img: "/static/media/work01.c0736d73b992e46e2dad.png",
            siteName: "らぅめんの善栄",
            release: "2022/07/19",
            webType: "コーポレートサイト",
            url: "https://raumennoyoshiei.com/",
            positionTop: "SmartGenz",
            positionDesign: "SmartGenz",
            positionCoding: "SMartGenz",
            positionServer: "SMartGenz",
        },
    ];

    // List of all cars satisfing all the filters
    const [filteredList, setFilteredList] = useState(webList);

    // Selected Brand name filter
    const [selectedBrand, setSelectedBrand] = useState("");

    const filterByBrand = (filteredData) => {
        // Avoid filter for empty string
        if (!selectedBrand) {
            return filteredData;
        }

        const filteredWeb = filteredData.filter(
            (webList) => webList.name.split(" ").indexOf(selectedBrand) !== -1
        );
        return filteredWeb;
    };

    // Update seletedBrand state
    const handleBrandChange = (event) => {
        setSelectedBrand(event.target.value);
    };

    useEffect(() => {
        var filteredData = filterByBrand(webList);
        setFilteredList(filteredData);
    }, [selectedBrand]);

    return (
        <>
            {/* <div className="brand-filter">
				<div>Filter by Brand :</div>
				<select
					id="brand-input"
					value={selectedBrand}
					onChange={handleBrandChange}
				>
					<option value="">All</option>
					<option value="foods">飲食</option>
					<option value="portSite">ポートフォリオサイト</option>
				</select>
			</div>
			<div>Filter by Year</div>
			{filteredList.map((web, index) => (
				<section className="wrk-main-sec" key={index}>
					<div className="wrk-img">
						<img src={`${web.img}`} alt="" />
					</div>
					<div className="wrk-ttl">{`${web.siteName}`}</div>
					<div className="wrk-desc"></div>
					<table border="1" className="wrk-table">
						<tr>
							<th>公開</th>
							<th>{`${web.release}`}</th>
						</tr>
						<tr>
							<th>種類</th>
							<th>{`${web.webType}`}</th>
						</tr>
						<tr>
							<th>URL</th>
							<th>
								<a href={`${web.url}`} target="_blank">
									{`${web.url}`}
								</a>
							</th>
						</tr>
						<tr>
							<th>担当</th>
							<td>
								<dl>
									<dt>企画・情報設計</dt>
									<dd>{`${web.positionTop}`}</dd>
									<dt>デザイン</dt>
									<dd>{`${web.positionDesign}`}</dd>
									<dt>コーディング</dt>
									<dd>{`${web.positionCoding}`}</dd>
									<dt>サーバーサイド</dt>
									<dd>{`${web.positionServer}`}</dd>
								</dl>
							</td>
						</tr>
					</table>
				</section>
			))} */}
            <section className="wrk-main-sec">
                <div className="wrk-img">
                    <img src={work01} alt="" />
                </div>
                <div className="wrk-ttl">らぅめんの東栄</div>
                <div className="wrk-desc"></div>
                <table border="1" className="wrk-table">
                    <tr>
                        <th>公開</th>
                        <th>2022/07/19</th>
                    </tr>
                    <tr>
                        <th>概要</th>
                        <th>善栄ラーメンのウェブサイトは、訪問者に大きな印象を与えるようにデザインされています。サイトのメインカラーは、熱意や励ましを連想させる、大胆で鮮やかなオレンジ。この生き生きとした色合いが、お客さまの来店を促します。</th>
                    </tr>
                    <tr>
                        <th>URL</th>
                        <th>
                            <a
                                href="https://raumennoyoshiei.com/"
                                target="_blank"
                            >
                                https://raumennoyoshiei.com/
                            </a>
                        </th>
                    </tr>
                    {/* <tr>
                        <th>担当</th>
                        <td>
                            <dl>
                                <dt>企画・情報設計</dt>
                                <dd>SmartGenz</dd>
                                <dt>デザイン</dt>
                                <dd>SmartGenz</dd>
                                <dt>コーディング</dt>
                                <dd>SmartGenz</dd>
                                <dt>サーバーサイド</dt>
                                <dd>SmartGenz</dd>
                            </dl>
                        </td>
                    </tr> */}
                </table>
            </section>
            <section className="wrk-main-sec">
                <div className="wrk-img">
                    <img src={work02} alt="" />
                </div>
                <div className="wrk-ttl">Bilier（ビリア）</div>
                <div className="wrk-desc"></div>
                <table border="1" className="wrk-table">
                    <tr>
                        <th>公開</th>
                        <th>2022/02/05</th>
                    </tr>
                    <tr>
                        <th>概要</th>
                        <th>Bilierの洗練されたウェブサイトテンプレートは、日本のお客様を念頭に置き、シンプルかつパワフルなユーザークスペリエンスを実現することを念頭にデザインされています。
                        <br />また、グローバルな顧客もターゲットとしているため、国内外を問わず同じ魅力的なデザインを提供できるようなウェブサイトとして構築されています。
                        <br/>その結果、どのようなユーザーであっても、親しみやわかりやすいフォーマットで、簡単にウェブサイトを操作することができるようにしました。</th>
                    </tr>
                    <tr>
                        <th>URL</th>
                        <th>
                            <a
                                href="https://bilier.smartgenz.com/"
                                target="_blank"
                            >
                                https://bilier.smartgenz.com/
                            </a>
                        </th>
                    </tr>
                    {/* <tr>
                        <th>担当</th>
                        <td>
                            <dl>
                                <dt>企画・情報設計</dt>
                                <dd>SmartGenz</dd>
                                <dt>デザイン</dt>
                                <dd>SmartGenz</dd>
                                <dt>コーディング</dt>
                                <dd>SmartGenz</dd>
                                <dt>サーバーサイド</dt>
                                <dd>SmartGenz</dd>
                            </dl>
                        </td>
                    </tr> */}
                </table>
            </section>
            <section className="wrk-main-sec">
                <div className="wrk-img">
                    <img src={work03} alt="" />
                </div>
                <div className="wrk-ttl">DAYMY（ディミー）</div>
                <div className="wrk-desc"></div>
                <table border="1" className="wrk-table">
                    <tr>
                        <th>公開</th>
                        <th>2022/02/05</th>
                    </tr>
                    <tr>
                        <th>概要</th>
                        <th>Daymy（ディミー）は、BtoBのスタートアップ企業を想定した、シンプルでわかりやすいWebサイトです。使いやすさを重視した最小限のアニメーションで、明確なメッセージを伝えるページを作成しました。実用的で最適なユーザーエクスペリエンスを求める企業に最適な、ホームページです。</th>
                    </tr>
                    <tr>
                        <th>URL</th>
                        <th>
                            <a
                                href="https://daymy.smartgenz.com/"
                                target="_blank"
                            >
                                https://daymy.smartgenz.com/
                            </a>
                        </th>
                    </tr>
                    {/* <tr>
                        <th>担当</th>
                        <td>
                            <dl>
                                <dt>企画・情報設計</dt>
                                <dd>SmartGenz</dd>
                                <dt>デザイン</dt>
                                <dd>SmartGenz</dd>
                                <dt>コーディング</dt>
                                <dd>SmartGenz</dd>
                                <dt>サーバーサイド</dt>
                                <dd>SmartGenz</dd>
                            </dl>
                        </td>
                    </tr> */}
                </table>
            </section>
            <section className="wrk-main-sec">
                <div className="wrk-img">
                    <img src={work04} alt="" />
                </div>
                <div className="wrk-ttl">Finance Business（ファイナンスビジネス）</div>
                <div className="wrk-desc"></div>
                <table border="1" className="wrk-table">
                    <tr>
                        <th>公開</th>
                        <th>2022/02/05</th>
                    </tr>
                    <tr>
                        <th>概要</th>
                        <th>FCは、金融業界のニーズに応えるためにデザインされたWebサイトです。クラシックな白とプロフェッショナルなグリーンを融合させたビジュアルで、あらゆるビジネスに欠かせない専門性と信頼性のイメージを訴求しています。正確で、包括的で、信頼できる、起業家やビジネスオーナーがその可能性を最大限に発揮できるような内容になっています。</th>
                    </tr>
                    <tr>
                        <th>URL</th>
                        <th>
                            <a
                                href="https://finance.smartgenz.com/"
                                target="_blank"
                            >
                                https://finance.smartgenz.com/
                            </a>
                        </th>
                    </tr>
                    {/* <tr>
                        <th>担当</th>
                        <td>
                            <dl>
                                <dt>企画・情報設計</dt>
                                <dd>SmartGenz</dd>
                                <dt>デザイン</dt>
                                <dd>SmartGenz</dd>
                                <dt>コーディング</dt>
                                <dd>SmartGenz</dd>
                                <dt>サーバーサイド</dt>
                                <dd>SmartGenz</dd>
                            </dl>
                        </td>
                    </tr> */}
                </table>
            </section>
            <section className="wrk-main-sec">
                <div className="wrk-img">
                    <img src={work05} alt="" />
                </div>
                <div className="wrk-ttl">Neru（ネル）</div>
                <div className="wrk-desc"></div>
                <table border="1" className="wrk-table">
                    <tr>
                        <th>公開</th>
                        <th>2022/02/05</th>
                    </tr>
                    <tr>
                        <th>概要</th>
                        <th>Neruは、女性のネイルアートをテーマにしたスタイリッシュなウェブサイトです。ネイルサロンをテーマにデザインされ、白と黒を基調とした洗練されたエレガントなデザインとなっています。マニキュアやペディキュアに関するアドバイスやヒントを提供するほか、お近くのサロンを探したり、最新のトレンドを発見したり、ネイル業界とつながる機会も提供してくれるホームページです。</th>
                    </tr>
                    <tr>
                        <th>URL</th>
                        <th>
                            <a
                                href="https://neru.smartgenz.com/"
                                target="_blank"
                            >
                                https://neru.smartgenz.com/
                            </a>
                        </th>
                    </tr>
                    {/* <tr>
                        <th>担当</th>
                        <td>
                            <dl>
                                <dt>企画・情報設計</dt>
                                <dd>SmartGenz</dd>
                                <dt>デザイン</dt>
                                <dd>SmartGenz</dd>
                                <dt>コーディング</dt>
                                <dd>SmartGenz</dd>
                                <dt>サーバーサイド</dt>
                                <dd>SmartGenz</dd>
                            </dl>
                        </td>
                    </tr> */}
                </table>
            </section>
            <section className="wrk-main-sec">
                <div className="wrk-img">
                    <img src={work06} alt="" />
                </div>
                <div className="wrk-ttl">NIX Ⅱ（ニクシ）</div>
                <div className="wrk-desc"></div>
                <table border="1" className="wrk-table">
                    <tr>
                        <th>公開</th>
                        <th>2022/02/05</th>
                    </tr>
                    <tr>
                        <th>概要</th>
                        <th>NIX Ⅱ（ニクシ）は、デジタルマーケティングの標準に合わせたWebサイトです。デジタルマーケティングをテーマに、最新のWebサイトデザインを実現しています。トップページのデザインは、ユーザーに強いインパクトを与えるために、重厚な色の組み合わせが特徴です。他のデジタルマーケティングサイトとの差別化を図り、潜在顧客を引き寄せます。</th>
                    </tr>
                    <tr>
                        <th>URL</th>
                        <th>
                            <a
                                href="https://nix.smartgenz.com/"
                                target="_blank"
                            >
                               https://nix.smartgenz.com/
                            </a>
                        </th>
                    </tr>
                    {/* <tr>
                        <th>担当</th>
                        <td>
                            <dl>
                                <dt>企画・情報設計</dt>
                                <dd>SmartGenz</dd>
                                <dt>デザイン</dt>
                                <dd>SmartGenz</dd>
                                <dt>コーディング</dt>
                                <dd>SmartGenz</dd>
                                <dt>サーバーサイド</dt>
                                <dd>SmartGenz</dd>
                            </dl>
                        </td>
                    </tr> */}
                </table>
            </section>

        </>
    );
}
export default HomePage;
